import { LoadingButton } from "@mui/lab";
import {
  Alert,
  AlertTitle,
  Autocomplete,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Stack,
  TextField,
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { isValidEmail } from "../helpers/ExtraHelpers";
import Formservice from "./../service/Formservice";
import PGIService from "./../service/PGIService";
import logo from "./logo.png";
import Message from "./Message";

function Accueil() {
  const [loadPost, setLoadPost] = useState(false);
  const [poste, setPoste] = React.useState([]);
  const [identif, setIdentif] = React.useState({});
  const [ref, setRef] = useState("");
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const id = params.get("ref");
  const [load, setLoad] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = React.useState({
    open: false,
    color: "green",
    messageInfo: "",
  });
  const { open, color, messageInfo } = message;
  const [form, setForm] = useState({
    id_poste: "",
    email: "",
    notif: false,
  });
  const navigate = useNavigate();
  const [error, setError] = useState("");

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm({ ...form, [name]: value });

    if (name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        setError("Veuillez entrer une adresse e-mail valide.");
      } else {
        setError("");
      }
    }
  };

  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const handleinterne = () => {
    Formservice.saveacceuil(form)
      .then((result) => {
        if (result.status) {
          setRef(result.data);
          navigate("/etatcivil?ref=" + result.data);
        } else {
        }
      })
      .catch((err) => {});
  };

  const handleenvoie = () => {
    if (form.id_poste === "") {
      setMessage({
        ...message,
        open: true,
        color: "red",
        messageInfo: "Veuillez choisir un poste de votre choix",
      });
    } else if (!isValidEmail(form.email, false)) {
      setMessage({
        ...message,
        open: true,
        color: "red",
        messageInfo: "Veuillez verifier votre adresse email",
      });
    } else {
      setSubmitting(true);
      Formservice.saveacceuil(form)
        .then((result) => {
          if (result.status) {
            setMessage({
              ...message,
              open: true,
              color: "green",
              messageInfo: "Succès",
            });
            setRef(result.data);
            setLoad(true);
            //navigate('/etatcivil?ref='+result.data);
          } else {
            setMessage({
              ...message,
              open: true,
              color: "red",
              messageInfo: "Erreur",
            });
          }
        })
        .catch((err) => {
          setMessage({
            ...message,
            open: true,
            color: "red",
            messageInfo: "erreur",
          });
        })
        .finally(() => {
          setSubmitting(false);
        });
    }
  };

  useEffect(() => {
    setLoadPost(true);
    Formservice.liste()
      .then((result) => {
        if (result && result.data) {
          setPoste(result.data);
        } else {
        }
      })
      .finally(() => {
        setLoadPost(false);
      });
    if (id !== null && id !== undefined) {
      PGIService.details(id).then((result) => {
        if (result && result.data) {
          setIdentif(result.data);
          setForm({ ...form, email: result.data.email });
        } else {
        }
      });
    }
  }, []);

  function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }

  const isMobile = window.innerWidth <= 722;
  console.log("ato e", isMobile);

  return (
    <Grid
      container
      bgcolor={"#fff"}
      display={"flex"}
      justifyContent={"center"}
      sx={{ mt: { xs: 0, md: 2 } }}
    >
      <Message
        open={open}
        color={color}
        messageInfo={messageInfo}
        handleClose={handleCloseMessage}
      />
      <header
        style={{
          height: "50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      ></header>
      <Grid
        item
        xs={12}
        md={10}
        lg={7}
        minHeight={"90vh"}
        borderRadius={"20px"}
        border={"2px rgba(11, 93, 208,0.5) solid "}
        boxShadow="0px 4px 10px rgba(7,71,161,0.4)"
        display={"flex"}
        flexDirection={"column"}
        p={2.5}
      >
        <main>
          <Grid container item xs={12}>
            <img
              src={logo}
              className="App-logo"
              alt="logo"
              style={{ maxWidth: "10%", maxHeight: "20%", marginLeft: "40%" }}
            />
          </Grid>

          <Grid container item xs={12} justifyContent="center">
            {id == null && (
              <>
                <Grid item xs={12} container justifyContent="center">
                  <h1 style={{ marginBottom: "10px" }}>Soumission Dossier</h1>
                  <Grid container justifyContent="center">
                    <Grid item xs={12} md={6} container justifyContent="center">
                      <Alert
                        severity="info"
                        variant="outlined"
                        sx={{ borderLeft: "3px solid #5e9df7ff" }}
                      >
                        <AlertTitle>Instruction</AlertTitle>
                        1-Veuillez choisir le poste qui vous intéresse
                        <br />
                        2-Veuillez entrer l'adresse e-mail valide
                      </Alert>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Grid
                      container
                      mt={4}
                      display={"flex"}
                      flexDirection={"row"}
                      spacing={2}
                    >
                      <Grid item xs={12} justifyContent="center">
                        <FormControl fullWidth size="small">
                          <Autocomplete
                            loading={loadPost}
                            loadingText={"Chargement de données ..."}
                            options={poste}
                            getOptionLabel={(option) =>
                              option.libelle_type +
                                " - " +
                                option.description || ""
                            }
                            onChange={(event, value) =>
                              setForm({
                                ...form,
                                id_poste: value?.id_type || "",
                              })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Poste souhaité *"
                                placeholder="Choisissez un poste"
                                InputProps={{
                                  ...params.InputProps,
                                  startAdornment: (
                                    <Stack
                                      direction="row"
                                      spacing={1}
                                      sx={{ ml: 1, color: "text.secondary" }}
                                    >
                                      {/* <WorkIcon fontSize="small" /> */}
                                      {params.InputProps.startAdornment}
                                    </Stack>
                                  ),
                                }}
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} justifyContent="center">
                        <TextField
                          required
                          fullWidth
                          style={{ marginBottom: "20px" }}
                          InputProps={{ style: { height: "50px" } }}
                          id="outlined-basic"
                          size="small"
                          label="E-mail"
                          variant="outlined"
                          name="email"
                          value={form.email}
                          onChange={handleChange}
                          error={!!error}
                          helperText={error}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    container
                    justifyContent="center"
                    alignItems="center"
                    style={{ marginBottom: "20px" }}
                  >
                    {!load && (
                      <FormControlLabel
                        // sx={{ display: id !== null ? "flex" : "none" }}
                        control={
                          <Checkbox
                            checked={isChecked}
                            onChange={handleCheckboxChange}
                          />
                        }
                        sx={{ textAlign: "center" }}
                        label="Me notifier si mon dossier est incomplet"
                      />
                    )}
                  </Grid>
                  {load && (
                    <>
                      <Grid item xs={12} container justifyContent="center">
                        <label
                          required
                          style={{ width: "70%", marginBottom: "0px" }}
                        >
                          Veuillez consulter votre courriel pour le lien et
                          suivre la soumission en ligne. Avant de continuer,
                          veuillez rassembler ce qui est nécessaire:
                        </label>
                      </Grid>
                      <Grid item xs={12} container justifyContent="center">
                        <ul style={{ width: "70%", marginBottom: "20px" }}>
                          <li>Diplôme disponible sous forme de PDF ou image</li>
                          <li>Une photo d'identité en PNG ou JPG</li>
                          <li>
                            Attestation de travail disponible en version
                            numérisée
                          </li>
                          <li>Une lettre de motivation au format PDF</li>
                          <li>Un scan de la Carte NIF et STAT si disponible</li>
                        </ul>
                      </Grid>
                      <Grid item xs={12} container justifyContent="center">
                        <label
                          style={{
                            width: "70%",
                            marginBottom: "20px",
                            color: "red",
                          }}
                        >
                          NB : Veuillez compléter toutes les informations, car
                          elles seront utilisées pour remplir le modèle de CV du
                          FID
                        </label>
                      </Grid>
                    </>
                  )}
                </Grid>
              </>
            )}
            {id !== null && (
              <Grid container item xs={12} justifyContent="center">
                <h1 style={{ marginBottom: "10px" }}>
                  Mise à jour CV en ligne
                </h1>
                <Grid item xs={12} container justifyContent="center">
                  <fieldset
                    style={{
                      width: "90%",
                      marginBottom: "20px",
                      padding: "0 15px",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                    }}
                  >
                    <legend>Informations</legend>
                    <Grid container spacing={3}>
                      <Grid item xs={3}>
                        <label>Nom :</label>
                      </Grid>
                      <Grid item xs={9}>
                        <label>{identif.last_name}</label>
                      </Grid>
                      <Grid item xs={3}>
                        <label>Prénom(s) :</label>
                      </Grid>
                      <Grid item xs={9}>
                        <label>{identif.first_name}</label>
                      </Grid>
                      <Grid item xs={3}>
                        <label>Direction :</label>
                      </Grid>
                      <Grid item xs={9}>
                        <label>{identif.direction_name}</label>
                      </Grid>
                      <Grid item xs={3}>
                        <label>Service :</label>
                      </Grid>
                      <Grid item xs={9}>
                        <label>{identif.service_name}</label>
                      </Grid>
                      <Grid item xs={3}>
                        <label>Fonction :</label>
                      </Grid>
                      <Grid item xs={9}>
                        <label>{identif.function_name}</label>
                      </Grid>
                    </Grid>
                  </fieldset>
                </Grid>
                <Grid item xs={12} container justifyContent="center">
                  <Button
                    variant="outlined"
                    color="primary"
                    style={{ fontWeight: 600, marginBottom: "20px" }}
                    onClick={handleinterne}
                  >
                    Continuer
                  </Button>
                </Grid>
              </Grid>
            )}
            {!load && id == null && (
              <Grid item xs={12} container justifyContent="center">
                <LoadingButton
                  loading={submitting}
                  variant="contained"
                  color="primary"
                  style={{ fontWeight: 600, marginBottom: "20px" }}
                  onClick={handleenvoie}
                >
                  ENREGISTRER
                </LoadingButton>
              </Grid>
            )}
          </Grid>
        </main>
        <footer
          style={{
            color: "#0747a1",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          &copy; {new Date().getFullYear()} FID - FONDS D'INTERVENTION POUR LE
          DEVELOPPEMENT
        </footer>
      </Grid>
    </Grid>
  );
}

export default Accueil;
